export default __webpack_public_path__ + "static/media/fmWebApp2.62412d9b.jpg";